const trillion = 1000000000000;
const billion = 1000000000;
const million = 1000000;
const oneHundredThousand = 100000;

export { trillion, billion, million, oneHundredThousand };
